export const FIELDS = {
  ITN: 'itn',
  EMAIL: 'email'
}
